import { render } from "./richtextset.vue?vue&type=template&id=51b295a8&scoped=true"
import script from "./richtextset.vue?vue&type=script&lang=js"
export * from "./richtextset.vue?vue&type=script&lang=js"

import "./richtextset.vue?vue&type=style&index=0&id=51b295a8&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51b295a8"]])

export default __exports__